<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>
        <label>連携事例登録</label>
      </h1>
    </div>

    <!-- 連携事例登録(H101) -->
    <div>
      <!-- 入力フォーム -->
      <form [formGroup]="h101InputForm">
        <!-- 分科会情報 -->
        <div class="cooperation-information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項を記載後、「プレビュー／一時保存」ボタンへお進みください。<br />
              <label class="warning"
                >【必須】の項目は入力必須です。必ずご記載ください。 </label
              ><br />
              事例の掲載にあたっては、連携している団体の了承を得た上で登録してください。<br />
              運営事務局の承認後に一般公開されます。項目毎の公開、非公開は以下の凡例をご参照ください。<br />
              <!-- 公開 -->
              <p-tag value="公開" styleClass="public-tag"></p-tag>
              …一般公開(ウェブサイト上で公開します)<br />
              <!-- 非公開 -->
              <p-tag value="非公開" styleClass="private-tag"></p-tag>
              …公開しません
            </label>
          </div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>事例タイトル・概要</h2>
          </div>
          <!-- 連携事例情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- タイトル -->
              <tr>
                <td class="item-input-name">
                  タイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※連携事例のタイトルを<label class="warning">30字</label
                    >以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="title"
                    placeholder="例）デジタルで住民を繋ぐ、みんなハッピーOOOプロジェクト"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="h101InputForm.get('title')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 取組概要 -->
              <tr>
                <td class="item-input-name">
                  取組概要
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">200字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-200"
                    formControlName="attemptoverview"
                    placeholder="どのような団体が、どのような地域課題を、どのように解決したのか簡潔にご記載ください。&#13;&#10;例）○○市と○○を提供する〇〇社が協力し、地域コミュニティをデジタル化することで、情報伝達の迅速化や地域のつながり強化、地域経済の促進、ペーパーレスによるCO2削減等、持続可能なまちづくりに取り組んだ。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('attemptoverview')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <div class="sub-title">
            <h2>事例イメージ（図・写真）</h2>
          </div>
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 図・写真① -->
              <tr>
                <td class="item-input-name">
                  図・写真①
                  <span class="required">【必須】</span>
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      登録する事例に関する画像を、png/jpeg/jpg(最大5MB)の<br />
                      いずれかの形式で、ファイルをアップロードしてください。
                    </div>
                  </div>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※横向きの画像をアップロードしてください
                  </div>
                  <p-fileUpload
                    #caseImage1
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="uploadFile($event, caseImage1, 'case_image1')"
                    (onRemove)="deleteFile('case_image1')"
                    (onClear)="deleteFile('case_image1')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="caseImgId1"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="searchResultsList.case_image1.file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ searchResultsList.case_image1.name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('case_image1')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('case_image1')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真①タイトル -->
              <tr>
                <td class="item-input-name">
                  図・写真①タイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">20字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="case_image1_caption"
                    placeholder="画像の下に表示する画像のタイトル・説明をご記載ください。"
                    (change)="checkRequiredImgCaption('case_image1')"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('case_image1_caption')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真２ -->
              <tr>
                <td class="item-input-name">
                  図・写真②
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      登録する事例に関する画像を掲載する場合は、<br />
                      png/jpeg/jpg(最大5MB)のいずれかの形式で、ファイルを<br />
                      アップロードしてください。
                    </div>
                  </div>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-fileUpload
                    #caseImage2
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="uploadFile($event, caseImage2, 'case_image2')"
                    (onRemove)="deleteFile('case_image2')"
                    (onClear)="deleteFile('case_image2')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="caseImgId2"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="searchResultsList.case_image2.file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ searchResultsList.case_image2.name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('case_image2')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('case_image2')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真２タイトル -->
              <tr>
                <td class="item-input-name">図・写真②タイトル</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">20字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="case_image2_caption"
                    placeholder="画像の下に表示する画像のタイトル・説明をご記載ください。（画像を添付する場合は必須）"
                    (change)="checkRequiredImgCaption('case_image2')"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('case_image2_caption')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>基本情報</h2>
          </div>
          <!-- 連携事例情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 代表地方公共団体等 -->
              <tr>
                <td class="item-input-name">
                  代表地方公共団体等
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※代表地方公共団体等の都道府県を選択してください
                  </div>
                  <p-dropdown [options]="prefectureIdCodeList" optionLabel="sp_name" optionValue="sp_name"
                    placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                    formControlName="prefectures"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="h101InputForm.get('prefectures')">
                  </app-validator-message>
                  <div class="warning-text">
                    ※<label class="warning">30字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-100"
                    formControlName="public_representative"
                    placeholder="当該連携事例の地方公共団体名をご記載ください。（例：〇〇県〇〇市）&#13;&#10;複数団体と連携した場合は、代表の1団体のみご記載ください。&#13;&#10;当プラットフォーム会員団体の場合は、登録されている表記でご記載ください。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('public_representative')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 代表民間団体等代表 -->
              <tr>
                <td class="item-input-name">
                  代表民間団体等
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">30字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-100"
                    formControlName="private_representatibe"
                    placeholder="当該連携事例の民間団体等名をご記載ください。&#13;&#10;複数団体が連携した場合は、代表1団体のみご記載ください。&#13;&#10;当プラットフォーム会員団体の場合は、登録されている表記でご記載ください。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('private_representatibe')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 他の連携団体等 -->
              <tr>
                <td class="item-input-name">他の連携団体等</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">100字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-100"
                    formControlName="other_cooperation"
                    placeholder="複数団体が連携した場合、代表団体以外のすべての団体名をご記載ください。&#13;&#10;当プラットフォーム会員団体の場合は、登録されている表記でご記載ください。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('other_cooperation')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 事例タグ -->
              <tr>
                <td class="item-input-name">
                  事例タグ
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      代表連携団体が地方創生SDGs官民連携プラットフォーム会員同士の場合は、チェックを入れてください。
                    </div>
                  </div>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div
                    class="p-d-flex p-as-center checkbox-list"
                    *ngFor="let dicData of getDicList(2017)"
                  >
                    <p-checkbox
                      name="10"
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="h101InputForm.controls['case_tag']"
                    >
                    </p-checkbox>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('case_tag')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- カテゴリ -->
              <tr>
                <td class="item-input-name">
                  カテゴリ
                  <span class="required">【必須】</span><br />
                  ※最大３つまで選択可
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information multi-line">
                  <div
                    class="two-line-content"
                    *ngFor="let category of categoryList"
                  >
                    <!-- カテゴリ大項目 -->
                    {{ category.class_name1 }}
                    <!-- カテゴリ中項目 -->
                    <div
                      class="category-checkbox"
                      *ngFor="let list of category.rec"
                    >
                      <p-checkbox
                        [label]="list.class_name2"
                        [value]="list.value"
                        [formControl]="h101InputForm.controls.category"
                      ></p-checkbox>
                    </div>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('category')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 事業費 -->
              <tr>
                <td class="item-input-name">事業費</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※公開可能な場合は、登録する事例の事業費用（“万円”単位）及び期間について<label
                      class="warning"
                      >50字</label
                    >以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="business_cost"
                    placeholder="例）○○○万円（2019年~2022年）"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('business_cost')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 目指すSDGsゴール -->
              <tr>
                <td class="item-input-name">
                  目指すSDGsゴール
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  ※複数選択可
                  <div class="multi-line">
                    <div
                      class="p-d-flex p-as-center checkbox-list two-line-content"
                      *ngFor="let dicData of getDicList(3)"
                    >
                      <p-checkbox
                        [value]="dicData.sp_code"
                        [formControl]="h101InputForm.controls.sdgs_goal"
                      >
                      </p-checkbox>
                      <div class="checkbox-img">
                        <img [src]="dicData.sp_ext" />
                      </div>
                      <div class="p-as-center">
                        {{ dicData.sp_code + "　" + dicData.sp_name }}
                      </div>
                    </div>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('sdgs_goal')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 事業化までの期間 -->
              <tr>
                <td class="item-input-name">
                  事業化までの期間<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※官民連携に向けた最初の打合せが開始した日等から、協定・契約締結、運用開始等事業化が実現した日までの期間を<label
                      class="warning"
                      >50字</label
                    >以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="coopstart_season"
                    placeholder="例）202〇年〇月~202〇年〇月"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('coopstart_season')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>取組内容</h2>
          </div>
          <!-- 連携事例情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- この取組で解決した課題 -->
              <tr>
                <td class="item-input-name">
                  この取組で解決した課題
                  <span class="required">【必須】</span><br />
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">400字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-400"
                    formControlName="clear_agenda"
                    placeholder="どのような地域課題を解決したのか簡潔にご記載ください。&#13;&#10;例）&#13;&#10;○○市では、地域住民同士のつながりの希薄化や地域経済の停滞が慢性的な課題となっていた。&#13;&#10;また、近年では、新型コロナウイルスの影響により接触機会を極力減らすことが求められていた。&#13;&#10;加えて、他の地域同様に、デジタル化やペーパーレスによるコスト削減やCO2削減が求められていた。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('clear_agenda')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 解決に向けた手法 -->
              <tr>
                <td class="item-input-name">
                  解決に向けた手法
                  <span class="required">【必須】</span><br />
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">400字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-400"
                    formControlName="method"
                    placeholder="上記地域課題に対し、どのような連携団体と、どの程度の期間で、どのように解決したのかご記載ください。&#13;&#10;例）○○市と○○を提供する○○社が連携することにより、○○市から住民への連絡手段をデジタル化し、住民同士がオンライン上で交流できる△△プロジェクト実施した。住民は、スマートフォンアプリまたはパソコン等にて○○市からのお知らせや地域商店街などのお得情報を見たり、住民同士で情報交換したりすることができる。&#13;&#10;このように、地域コミュニティをデジタル化することで、情報伝達の迅速化や地域のつながり強化、地域経済の促進、ペーパーレスによるCO2削減等、持続可能なまちづくりを実現した。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('method')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真３ -->
              <tr>
                <td class="item-input-name">
                  図・写真③
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      登録する事例に関する画像を掲載する場合は、<br />
                      png/jpeg/jpg(最大5MB)のいずれかの形式で、ファイルを<br />
                      アップロードしてください。
                    </div>
                  </div>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-fileUpload
                    #overviewImage1
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="
                      uploadFile($event, overviewImage1, 'overview_image1')
                    "
                    (onRemove)="deleteFile('overview_image1')"
                    (onClear)="deleteFile('overview_image1')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="overviewImgId1"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="
                                  searchResultsList.overview_image1.file_path
                                "
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>
                              {{ searchResultsList.overview_image1.name }}
                            </div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('overview_image1')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('overview_image1')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真３タイトル -->
              <tr>
                <td class="item-input-name">図・写真③タイトル</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">20字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="overview_image1_caption"
                    placeholder="画像の下に表示する画像のタイトル・説明をご記載ください。（画像を添付する場合は必須）"
                    (change)="checkRequiredImgCaption('overview_image1')"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('overview_image1_caption')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真４ -->
              <tr>
                <td class="item-input-name">
                  図・写真④
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      登録する事例に関する画像を掲載する場合は、<br />
                      png/jpeg/jpg(最大5MB)のいずれかの形式で、ファイルを<br />
                      アップロードしてください。
                    </div>
                  </div>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-fileUpload
                    #overviewImage2
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="
                      uploadFile($event, overviewImage2, 'overview_image2')
                    "
                    (onRemove)="deleteFile('overview_image2')"
                    (onClear)="deleteFile('overview_image2')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="overviewImgId2"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="
                                  searchResultsList.overview_image2.file_path
                                "
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>
                              {{ searchResultsList.overview_image2.name }}
                            </div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('overview_image2')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('overview_image2')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真４タイトル -->
              <tr>
                <td class="item-input-name">図・写真④タイトル</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">20字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="overview_image2_caption"
                    placeholder="画像の下に表示する画像のタイトル・説明をご記載ください。（画像を添付する場合は必須）"
                    (change)="checkRequiredImgCaption('overview_image2')"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('overview_image2_caption')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>取組詳細</h2>
          </div>
          <!-- 連携事例情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 事業推進上の各団体の役割分担 -->
              <tr>
                <td class="item-input-name">事業推進上の各団体の役割分担</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">200字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-200"
                    formControlName="role_sharing"
                    placeholder="事業実施において、どのような団体が、どのような役割を担ったのかご記載ください。&#13;&#10;例）事業実施において、〇〇市役所は住民説明会を開催、〇〇社は、○○のサービス提供や企業版ふるさと納税等を通じた資金調達を実施。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('role_sharing')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 地域関係者との連携方法 -->
              <tr>
                <td class="item-input-name">
                  地域関係者との連携方法
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">200字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-200"
                    formControlName="coop_method"
                    placeholder="事業実施において、どのような地域関係者を、何のために、どのように巻き込んだのかご記載ください。&#13;&#10;例）スマートフォンは幅広い世代に普及しているが、使いこなせない高齢者も多い。そのため、市の広報媒体を利用し、デジタルコミュニケーションツールの使い方のわかりやすいマニュアルを掲載した。また市民のボランティアを募り、希望者へのフォローを行った。なお、地域商店街等の事業者へは、同ツールを経営に活用できる機能の利活用方法のセミナーを行った。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('coop_method')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 資金調達方法 -->
              <tr>
                <td class="item-input-name">
                  資金調達方法
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">100字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-100"
                    formControlName="funding_plan"
                    placeholder="資金調達手法の種別をご記載ください。&#13;&#10;例）「出資」、「個人借入」、「融資」、「補助金・助成金」、「クラウドファンディング」、「SIB」、「VC」、「企業版ふるさと納税」、「資金調達なし」等々"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('funding_plan')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 資金調達方法の補足 -->
              <tr>
                <td class="item-input-name">資金調達方法の補足</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">200字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-200"
                    formControlName="funding_plan_supplement"
                    placeholder="上記「資金調達方法」に関する補足情報や具体的な金額、資金調達において苦労したこと、工夫したこと等についてご記載してください。&#13;&#10;例）○○市2022年度○○予算：○○○万円（○○費）&#13;&#10;（○○補助金：○○○万円、追加資金分：○○万円）&#13;&#10;○○補助金は、○年○月から準備開始、○年○月申請、○年○月に承認された。加えて、○○社からの企業版ふるさと納税を通じて追加資金を得た。&#13;&#10;○○市含め自治体の抱える地域課題は多く、全ての課題に十分な資金を充てることができない場合もある。当事例では、複数の地域課題を包括的に対応できるよう事業設計することにより○○補助金の申請を行うことができた。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('funding_plan_supplement')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 事業推進上の課題・工夫 -->
              <tr>
                <td class="item-input-name">
                  事業推進上の課題・工夫<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">500字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-500"
                    formControlName="solution"
                    placeholder="以下の内容を参考にして事業推進において工夫した点を、ご記載ください。&#13;&#10;・当該事業を進めるにあたり、どの様な苦労があったか&#13;&#10;・苦労を乗り越えるために工夫した点は何か&#13;&#10;例）当事例では、事業準備段階から住民の理解を得ることに苦労するのではないかという懸念があったため、住民への説明を工夫した。&#13;&#10;自治体活動におけるデジタル化に関する他地域や海外の事例を事前に調査し、一番有効な手法は、経験してもらうことだと判明した。&#13;&#10;そのため、言葉でデジタル化を説明するのではなく、説明会にて実際に体験してもらい、デジタル化しても問題ない、多くのメリットを得られるということを理解していただいた。また、ツール実装後も浸透率を上げるため、個別説明会など細かく対応した。"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('solution')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>担当者</h2>
          </div>
          <!-- 連携事例情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 担当者のコメント -->
              <tr>
                <td class="item-input-name">担当者のコメント</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">500字</label>以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-500"
                    formControlName="responsible_person_comment"
                    placeholder="当該事業を通じてご自身が感じたことやメッセージ等をご自由にご記載ください。"
                    (change)="
                      checkRequiredImgCaption('responsible_person_image')
                    "
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('responsible_person_comment')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 担当者等の写真等 -->
              <tr>
                <td class="item-input-name">
                  担当者等の写真等
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      ご担当者の画像などを掲載する場合は、png/jpeg/jpgのいずれかの形式で、ファイル（最大5MB）をアップロードしてください。
                    </div>
                  </div>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-fileUpload
                    #responsiblePersonImage
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="
                      uploadFile(
                        $event,
                        responsiblePersonImage,
                        'responsible_person_image'
                      )
                    "
                    (onRemove)="deleteFile('responsible_person_image')"
                    (onClear)="deleteFile('responsible_person_image')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="responsiblePersonImgId"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="
                                  searchResultsList.responsible_person_image
                                    .file_path
                                "
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>
                              {{
                                searchResultsList.responsible_person_image.name
                              }}
                            </div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('responsible_person_image')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('responsible_person_image')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 写真等のタイトル -->
              <tr>
                <td class="item-input-name">写真等のタイトル</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">20字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="responsible_person_caption"
                    placeholder="画像の下に表示する画像のタイトル・説明をご記載ください。（画像を添付する場合は必須）"
                    (change)="
                      checkRequiredImgCaption('responsible_person_image')
                    "
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('responsible_person_caption')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>問い合わせ先</h2>
          </div>
          <!-- 連携事例情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 公開設定 -->
              <tr>
                <td class="item-input-name">
                  公開設定
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      「問い合わせ先」の公開範囲をご選択ください。
                    </div>
                  </div>
                </td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <p-dropdown
                    [options]="getDicList(2019)"
                    optionLabel="sp_name"
                    optionValue="sp_code"
                    placeholder="選択してください"
                    [showClear]="true"
                    [(ngModel)]="cooperation_open_default"
                    styleClass="information-Form-dropdown"
                    formControlName="cooperation_open"
                  ></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('cooperation_open')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 団体名称（全角） -->
              <tr>
                <td class="item-input-name">団体名称（全角）</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">100字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="organization_name"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('organization_name')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 部局名（全角） -->
              <tr>
                <td class="item-input-name">部局名（全角）</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">30字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="divition_name"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('divition_name')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 氏名（全角） -->
              <tr>
                <td class="item-input-name">氏名（全角）</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">20字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="responsible_person_name"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('responsible_person_name')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 電話番号（半角数字、ハイフン不要） -->
              <tr>
                <td class="item-input-name">
                  電話番号（半角数字、ハイフン不要）
                </td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">11字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="tel"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="h101InputForm.get('tel')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- eメールアドレス -->
              <tr>
                <td class="item-input-name">eメールアドレス</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">200字</label>以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext"
                    formControlName="email"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="h101InputForm.get('email')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title excellent-case-title">
            <h2>
              優良事例応募項目<label class="warning"
                >【※以下の欄は優良事例選定の応募の際に入力が必須の項目となります。必ずご記載ください。（応募期間中のみ入力可能）】</label
              >
            </h2>
          </div>
          <!-- 連携事例情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 応募にあたっての記載事項 -->
              <tr>
                <td class="item-input-name">
                  応募にあたっての記載事項
                  <br />
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description">
                      2023年度の選考テーマ<br />
                      &nbsp;&nbsp;&nbsp;&nbsp;■地方創生SDGsの視点<br />
                      &nbsp;&nbsp;&nbsp;&nbsp;■ステークホルダーとの連携<br />
                      &nbsp;&nbsp;&nbsp;&nbsp;■モデル性・波及性
                    </div>
                  </div>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※<label class="warning">800字</label>以内でご記載ください
                  </div>
                  <textarea
                    *ngIf="cooperationPeriodCheck == 'True'"
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-800"
                    formControlName="sdgs_perspective"
                    placeholder="【記載例】■項目は必須です。&#13;&#10;■地方創生SDGsの視点&#13;&#10;以下の内容を参考にして地方創生SDGｓの視点について、ご記載ください。&#13;&#10;・持続可能な地域社会の実現に向けたビジョンを持った取組であるか&#13;&#10;・経済・社会・環境の３側面の相乗効果・相互関連性を重視しているか &#13;&#10;・地域の課題解決やSDGsの達成に資する取組であるか&#13;&#10;&#13;&#10;■ステークホルダーとの連携&#13;&#10;以下の内容を参考にしてステークホルダーとの連携について、ご記載ください。&#13;&#10;・多様なステークホルダー（地方公共団体、住民、企業・金融機関、教育・研究機関、NPO等域内外の団体等）が参画しているか&#13;&#10;・住民の参加や理解が得られる取組であるか&#13;&#10;・各団体の強みを生かした連携ができているか&#13;&#10;&#13;&#10;■モデル性・波及性&#13;&#10;以下の内容を参考にしてモデル性・波及性について、ご記載ください。&#13;&#10;・他団体のモデルとなり普遍性が高い取組であるか&#13;&#10;・新規性やインパクトがあるか&#13;&#10;・今後発展する見込みがある事例であるか"
                  ></textarea>
                  <textarea
                    *ngIf="cooperationPeriodCheck != 'True'"
                    pInputTextarea
                    class="information-Form-inputtext p-text-area-800"
                    formControlName="sdgs_perspective"
                    placeholder="【記載例】■項目は必須です。&#13;&#10;■地方創生SDGsの視点&#13;&#10;以下の内容を参考にして地方創生SDGｓの視点について、ご記載ください。&#13;&#10;・持続可能な地域社会の実現に向けたビジョンを持った取組であるか&#13;&#10;・経済・社会・環境の３側面の相乗効果・相互関連性を重視しているか &#13;&#10;・地域の課題解決やSDGsの達成に資する取組であるか&#13;&#10;&#13;&#10;■ステークホルダーとの連携&#13;&#10;以下の内容を参考にしてステークホルダーとの連携について、ご記載ください。&#13;&#10;・多様なステークホルダー（地方公共団体、住民、企業・金融機関、教育・研究機関、NPO等域内外の団体等）が参画しているか&#13;&#10;・住民の参加や理解が得られる取組であるか&#13;&#10;・各団体の強みを生かした連携ができているか&#13;&#10;&#13;&#10;■モデル性・波及性&#13;&#10;以下の内容を参考にしてモデル性・波及性について、ご記載ください。&#13;&#10;・他団体のモデルとなり普遍性が高い取組であるか&#13;&#10;・新規性やインパクトがあるか&#13;&#10;・今後発展する見込みがある事例であるか"
                    disabled
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="h101InputForm.get('sdgs_perspective')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!h101InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- ヴァリデーションチェックメッセージ空白エリア-->
      <div class="p-d-flex p-jc-center error-area" *ngIf="h101InputForm.valid">
        <label class="warning platform-warning-text"> &nbsp; </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button
          pButton
          type="button"
          label="プレビュー／一時保存"
          class="button-default-size button1"
          (click)="moveH301()"
        ></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
